import { initialCommonState } from 'redux/initialState';
import { status } from 'constants/general';

import commonActionTypes from './action-types';

const commonReducer = (state = initialCommonState, { type, payload }) => {
  switch (type) {
    case commonActionTypes.SET_CONTEXT:
      return {
        ...state,
        context: payload,
      };

    case commonActionTypes.FETCH_DROPDOWNS:
      return {
        ...state,
        citiesList: {
          status: status.FETCHING,
        },
      };

    case commonActionTypes.FETCH_DROPDOWNS_SUCCESS:
      return {
        ...state,
        citiesList: {
          status: status.SUCCESS,
          details: payload,
        },
      };

    case commonActionTypes.FETCH_DROPDOWNS_FAIL:
      return {
        ...state,
        citiesList: {
          status: status.FAIL,
        },
      };

    case commonActionTypes.FETCH_FIREBASE_CONFIG:
      return {
        ...state,
        firebaseConfig: {
          status: status.FETCHING,
        },
      };

    case commonActionTypes.FETCH_FIREBASE_CONFIG_SUCCESS:
      return {
        ...state,
        firebaseConfig: {
          status: status.SUCCESS,
          details: payload,
        },
      };

    case commonActionTypes.FETCH_FIREBASE_CONFIG_FAIL:
      return {
        ...state,
        firebaseConfig: {
          status: status.FAIL,
        },
      };

    default:
      return state;
  }
};

export default commonReducer;
